export default __webpack_public_path__ + "bb4a18f03090d59dde3aec9479155bd1.svg";